import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import Toast from 'components/common_v2/toasts';

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

const ToastContainer = styled.div`
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 500px;
  width: calc(100% - 32px);
  pointer-events: none;

  @media (max-width: 600px) {
    width: calc(100% - 16px);
    max-width: none;
  }
`;

const ToastWrapper = styled.div`
  pointer-events: auto;
  animation: ${slideIn} 0.3s ease-out;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  overflow: hidden;
`;

const Alerts = ({ alerts }) => {
  if (!alerts.length) {
    return null;
  }

  return (
    <ToastContainer>
      {alerts.map((alert) => (
        <ToastWrapper
          key={alert.fingerprint}
          data-test-id={`toast-container-${alert.fingerprint}`}
        >
          <Toast {...alert} />
        </ToastWrapper>
      ))}
    </ToastContainer>
  );
};

Alerts.propTypes = {
  alerts: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.string,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    type: PropTypes.string,
    fingerprint: PropTypes.string
  }))
};

Alerts.defaultProps = {
  alerts: []
};

export default Alerts;
